module.exports = __webpack_public_path__ + "static/media/icon-youtube.8499da12.svg";